import z from 'zod';
import { productEntityFields } from './product-fields';

const formSchemas = {
  submitted: z.object({
    formId: z.string(),
    formName: z.string(),
    product: z.object({ ...productEntityFields }).optional(),
  }),
  clicked: z.object({
    formId: z.string(),
    formName: z.string(),
    clickText: z.string(),
    product: z.object({ ...productEntityFields }).optional(),
  }),
};

export default formSchemas;
